import type { Pricing, PricingPlans } from "@/schemas/pricing.schema";
import { pricingPlansSchema, pricingSchema } from "@/schemas/pricing.schema";
import { api } from "@/services/api";

export const pricingApi = {
  /**
   * Fetch all pricing plans (public endpoint)
   * Returns pricing for all supported currencies
   */
  async getPlans(): Promise<PricingPlans> {
    const { data } = await api.get<PricingPlans>("/pricing");
    return pricingPlansSchema.parse(data);
  },

  /**
   * Fetch organization-specific pricing (authenticated endpoint)
   * Returns pricing for the user's organization currency
   */
  async getOrganization(): Promise<Pricing> {
    const { data } = await api.get<Pricing>("/organization/pricing");
    return pricingSchema.parse(data);
  },
};
